<div class="floating-label">
    <input [formControlName]="controlName" [id]="inputId" type="file" [class]="inputClass" [attr.placeholder]="placeholderText | translate" [readOnly]="readonly" [accept]="accept" [ngClass]="{ 'no-icon': !showIcon }" autocomplete="off" />
    <label-extended-control [labelText]="labelText"></label-extended-control>
    <div *ngIf="showIcon" class="icon">
        <span [class]="iconClass"></span>
    </div>
    <field-error-display-control [displayError]="parentFormHelper.showFieldError(controlName)" [errorMsg]="parentFormHelper.getErrorMessageHtml(controlName)"> </field-error-display-control>
</div>
